import { drawComposerFrame } from './share-composer-render';

// One cache per GIF export, at its actual output resolution. Once the introductory
// count and monthly bars settle, the ink/chart/caption need only be painted once.
// The background and profile foil continue to move at every original timestamp.
// MP4 keeps its single-canvas GPU path; a second canvas can slow that encoder.
export function createComposerFrameRenderer(canvas, render) {
  let ink;
  return {
    draw(frame) {
      const options = { ...render, ...frame };
      if (render.model?.kind === 'profile' || !options.animateHero || options.time < 1.6) {
        drawComposerFrame(canvas, options); return;
      }
      const ctx = canvas.getContext('2d');
      if (!ctx) { drawComposerFrame(canvas, options); return; }
      if (!ink) {
        ink = document.createElement('canvas'); ink.width = canvas.width; ink.height = canvas.height;
        drawComposerFrame(ink, { ...options, layer: 'foreground', opaque: false });
      }
      drawComposerFrame(canvas, { ...options, layer: 'background' });
      ctx.drawImage(ink, 0, 0);
    },
    dispose() { if (ink) { ink.width = 1; ink.height = 1; ink = null; } },
  };
}
